var exports = {
  "H": "x93eb46d8--b7abff--btn",
  "D": "x93eb46d8--b7abff--title",
};

module.exports = exports;
